<template>
  <div class="addr">
    <van-cell-group>
      <van-field
      v-model="params.hometown"
      clearable
      label="所在地区"
      right-icon="arrow"
      placeholder="省市区县、乡镇等"
      @click="showAread"
      />
      <van-field
      v-model="params.username"
      clearable
      label="详细地址"
      placeholder="如道路、门牌号、小区、楼栋号、单元室等"
      @input="checkName"
      />
      <van-field
      v-model="params.intro"
      clearable
      label="位置名称"
      placeholder="例如：家、公司"
      @input="checkIntro"
      />
      
      <van-cell title="设为默认地址" label="提醒：每次下单时会使用该地址"  @click="radiod">
        <template slot="default">
          <van-checkbox v-model="checked" checked-color="#605C6B"></van-checkbox>
        </template>
      </van-cell>
    </van-cell-group>
    <van-popup v-model="showArea" position="bottom">
      <van-area 
      v-show="showArea" 
      :area-list="areaList" 
      @cancel="showArea = false"
      @confirm="onConfirmArea" />

    </van-popup>
    <div class="btn-box">
      <van-button size="large" @click="updateInfo" :disabled="submitbtn" color="#605C6B">创建地址</van-button>
    </div>
  </div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import AreaList from '../../../libs/area';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Image,Field, Icon, Picker, Area ,Cell, CellGroup, Button,ActionSheet,Checkbox, CheckboxGroup,Popup } from 'vant';
  export default {
    data(){
      return{
        params:{
         username:'',
         hometown:'',
         intro:'',
         sex:'',
         sexName:'男',
         avatar:'',
         avatar_url:'arrow'
       },
       showPicker:false,
       showArea:false,
       areaList:AreaList,
       submitbtn:true,
       checked:false
     }   
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    this.$appService.isShowReturn({state: true})
    var params={
      event_code: '编辑地址',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/CreateAddr.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
   onSelect(item) {
    this.params.sexName = item.name;
    if(item.name=='男'){
      this.params.sex =1
    }else{
      this.params.sex =2
    }
    this.showPicker = false;
    this.submitbtn=false
  },
  showAread(e){
    this.showArea=true;
  },
  onConfirmArea(value){
    this.params.hometown=value[0].name+value[1].name+value[2].name;
    this.params.province_id=value[0].code;
    this.params.city_id=value[1].code;
    this.params.area_id=value[2].code;
    this.showArea=false;
    this.submitbtn=false;
  },
  afterRead(file) {
    let params = new FormData()
    params.append('img', file.file)
    params.append('type',2)
    member.uploadImg(params).then(res => {
      if(res.data.state == 1) {
        this.params.avatar_url=res.data.data.img_url
        this.params.avatar=res.data.data.img
        this.submitbtn=false
      }
    })
  },
  checkName(value){
    this.submitbtn=false
    this.params.username=value
  },
  checkIntro(value){
    this.submitbtn=false
    this.params.intro=value
  },
  updateInfo(){
    member.updateInfo(this.params).then(res => {
      if(res.data.state == 1) {
       this.$toast.success('修改成功');
       this.getMemberInfo()
     }
   })
  },
  radiod(){
    if(this.radio){
      this.radio=true
    }else{
      this.radio=false
    }
  }
},
components: {
  [Image.name]:Image,
  [Field.name]:Field,
  [Icon.name]:Icon,
  [Picker.name]:Picker,
  [Area.name]:Area,   
  [CellGroup.name]:CellGroup,
  [Cell.name]:Cell,
  [Button.name]:Button,
  [ActionSheet.name]:ActionSheet,
  [Checkbox.name]:Checkbox,
  [CheckboxGroup.name]:CheckboxGroup,
  [Popup.name]:Popup, 
}
}
</script>
<style lang="scss">
.addr{
  margin-top: 20px;
  .van-cell{
    padding: 10px 15px;
    .van-icon__image{
      width: 40px;
      height: 40px;
      .van-image__img{
        border-radius: 30px;
      }
    }
    .van-cell__title, .van-cell__value{
      padding: 10px 0;
    }
  }
  .btn-box{
    padding: 20px;
    width: 90%;
    bottom: 0;
    position: fixed;
  }
  .van-checkbox{
    float: right;
    margin-top: 10px;
  }
}
</style>